import React from 'react';
import { Controller } from 'react-hook-form';

import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import FileDropzone from 'components/FileDropzone/FileDropzone';
import { inferMimeTypeFromName } from 'modules/FileManagerV2/utils/file/mimeFallback';

const FILE_MANAGER_ACCEPT =
  '.jpg, .jpeg, .png, .heic, .heif, .pdf, .doc, .docx, .xls, .xlsx, .txt, .mov, .wav, .mp3, .rtf, .mpeg, .mp4, .aac, .3gp, .avi, .wmv, .wma, .csv';

const ALLOWED_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'heic',
  'heif',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'txt',
  'mov',
  'wav',
  'mp3',
  'rtf',
  'mpeg',
  'mp4',
  'aac',
  '3gp',
  'avi',
  'wmv',
  'wma',
  'csv',
];

function makeUniqueNames(files, existingFiles = []) {
  const nameCountMap = new Map();
  existingFiles.forEach((file) => {
    nameCountMap.set(file.name, (nameCountMap.get(file.name) || 0) + 1);
  });
  return files?.map((file) => {
    let name = file.name;
    const [base, ext] = (() => {
      const idx = name.lastIndexOf('.');
      return idx !== -1 ? [name.slice(0, idx), name.slice(idx)] : [name, ''];
    })();

    while (nameCountMap.has(name)) {
      const count = nameCountMap.get(name);
      name = `${base}(${count})${ext}`;
      nameCountMap.set(file.name, count + 1);
    }
    nameCountMap.set(name, 1);
    const fallbackType = file.type || inferMimeTypeFromName(name);
    return new File([file], name, { type: fallbackType });
  });
}

function UploadInput({ control, errors }) {
  const onDropTransform = (acceptedFiles, currentFiles) => {
    const filtered = acceptedFiles.filter((file) => {
      const ext = file.name.split('.').pop().toLowerCase();
      return ALLOWED_EXTENSIONS.includes(ext);
    });
    return makeUniqueNames(filtered, currentFiles);
  };

  return (
    <div className="dropzone-wraper d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-3 col-12">
        <label className="p-medium">
          Source <span style={{ color: 'red' }}>*</span>
        </label>
      </div>
      <div className="col-md-9 col-12">
        <Controller
          name="files"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value = [] } }) => (
            <FileDropzone
              value={value}
              onChange={onChange}
              accept={FILE_MANAGER_ACCEPT}
              maxFiles={20}
              allowDirectory
              noDragEventsBubbling
              onDropTransform={onDropTransform}
            />
          )}
        />
        {errors?.files && <InputErrorMessage>Required</InputErrorMessage>}
      </div>
    </div>
  );
}

export default UploadInput;
